import { Backdrop, CircularProgress, Typography } from '@mui/material'
import React, { useState } from 'react'

import useStyles from './useStyles'
import InfoIcon from '@mui/icons-material/Info'
import { AddVersionModal } from '../../components/Modals/FeatureFlags/AddVersion'
import { VersionList } from './VersionList/VersionList'
// import BreadcrumbsComponent from './Breadcrumbs/Breadcrumbs'
import { featureFlagsAppPlatformCodes } from '../../utils/traducTypes'

export const FeactureFlags = () => {
  const classes = useStyles()
  const [loading] = useState(false)
  const [allversions, setallversions] = useState([])

  const addVersions = (plataform, versions) => {
    setallversions((allversions) => [...allversions, {
      appPlataformCode: plataform,
      versions
    }])
  }

  return (
    <div className={classes.root}>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* <BreadcrumbsComponent /> */}
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          Control de versiones de la aplicación Mi Estudio
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon
          style={{ fontSize: '2rem', color: '#00a78f', marginLeft: 10 }}
        />
        <Typography className={classes.subtitle}>
          En esta sección podrá gestionar las versiones de la aplicación Mi
          Estudio
        </Typography>
      </div>
      <AddVersionModal versions={allversions} />
      {featureFlagsAppPlatformCodes.map((plataform) => (
        <VersionList
          key={plataform.value}
          plataform={plataform}
          addVersions={addVersions}
        />
      ))}
    </div>
  )
}
